import React from "react";
import Container from "@mui/material/Container";

export const NotFoundPage = () => {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h3>Page Not Found !</h3>
    </Container>
  );
};
